import { atom } from 'jotai';
import type { z } from 'zod';

import type { attachmentDataSchema } from './channel/channel-attachment';

/**
 * Acloset 채팅 UI 전역 상태 (SecondSold + Sendbird 통합)
 *
 * **채팅 솔루션 마이그레이션 완료:**
 *
 * SecondSold 채팅을 기본으로 하고, Sendbird를 레거시 백업으로 유지합니다.
 * 사용자는 "구 채팅방 보기" 버튼을 통해 기존 Sendbird 채팅에 접근할 수 있습니다.
 *
 * **통합 상태 구조:**
 * - `open`: 채팅 UI의 열림/닫힘 상태 (양쪽 시스템 공통)
 * - `viewMode`: 현재 표시 중인 채팅 시스템 ('secondsold' | 'sendbird')
 * - `currentChannel`: Sendbird 채팅방 정보 (기존 호환성 유지)
 * - `secondSoldCurrentRoom`: SecondSold 채팅방 정보 (신규 추가)
 *
 * **기본 전략: SecondSold First**
 * - 채팅 아이콘 클릭 시 SecondSold 채팅이 기본으로 표시
 * - "구 채팅방 보기" 버튼으로 Sendbird 접근 가능
 * - 동일한 팝업 내에서 두 시스템 간 전환 지원
 */
export const aclosetChatStore = atom<{
  /**
   * 채팅 팝업 열림/닫힘 상태 (양쪽 시스템 공통)
   */
  open: boolean;

  /**
   * 기존 Sendbird 채팅방 정보 (호환성 유지)
   */
  currentChannel: {
    url: string;
    attachment?: z.output<typeof attachmentDataSchema>;
  };

  /**
   * SecondSold 채팅방 정보 (신규 추가)
   */
  secondSoldCurrentRoom: {
    roomID: number;
    attachment?: z.output<typeof attachmentDataSchema>;
  };
}>({
  open: false,

  // 기존 Sendbird 상태 (호환성 유지)
  currentChannel: {
    url: '',
  },

  // 새로운 SecondSold 상태
  secondSoldCurrentRoom: {
    roomID: 0,
  },
});
